import React from 'react'
import { PageLayout } from '../components/PageLayout'

const Home = () => (
  <PageLayout>
    <div className="flex items-center justify-center h-screen bg-black bg-opacity-50">
      <p className="text-center text-white xl:text-3xl text-xl italic px-8 border border-white rounded-lg mx-2 p-4">
        Hampton Jitney's charter department is dedicated to exceptional service, fulfilling unique 
        transportation needs. Whether it's a corporate event, school trip, wedding, or special occasion, 
        we offer personalized solutions, diverse vehicle options, professional drivers, and a strong 
        focus on safety and reliability. We handle logistics for a seamless experience. 
        Trust us to provide outstanding service and create unforgettable transportation tailored to your needs.
      </p>
    </div>
  </PageLayout>
)

export default Home